import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IFeature } from "../interfaces/ifeature";
import { FeatureService } from "../services/feature.service";
import { Observable } from "rxjs";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class FeaturesResolver implements Resolve<IFeature[]> {

    constructor(private featureService: FeatureService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IFeature[]> {
        return this.featureService.getAll();
    }
}
